import React from 'react'
import cx from 'classnames'

import './testimony.scss'

export type TestimonyProps = {
  className?: string
  img: string
  name: JSX.Element | string
  job: JSX.Element | string
  city?: JSX.Element | string
  testimony?: JSX.Element | string
}

export function Testimony({
  img,
  name,
  job,
  city,
  testimony,
  className,
}: TestimonyProps) {
  return (
    <div className={cx('testimony', className)}>
      <div className="picture" style={{ [`backgroundImage`]: `url(${img})` }} />
      <p className="name">{name}</p>
      <p className="job">{job}</p>
      {city && <p className="city">{city}</p>}
      <p>{testimony}</p>
    </div>
  )
}
